import React, { useEffect, useState } from 'react';
import { Formik, Form as FormMik } from 'formik';
import { Form, Button, Image } from 'react-bootstrap';

import * as Yup from 'yup';
import { useToast } from '../hooks/toast';
import ConfigIcon from '../assets/icon/opcoes.svg';
import IParametro from '../interfaces/IParametro';

import api from '../services/apiClient';

const initialValues = {
  seqEmpresa: 0,
  tempoAlertaVerde: 0,
  tempoAlertaAmarelo: 0,
  tempoAlertaVermelho: 0,
  exibeMensagemBoasVindas: false,
  mensagemBoasVindas: '',
  notificacaoNovoChat: false,
  notificacaoNovaMsg: false,
  permiteAcessoHstTodos: false,
  tocarTodosDepartamentos: false,
};

const validationSchemaParametros = Yup.object().shape({
  tempoAlertaVerde: Yup.number()
    .required('Esse campo é obrigatório')
    .min(0, 'O valor não pode ser menor do que zero.')
    .lessThan(
      Yup.ref('tempoAlertaAmarelo'),
      'O valor deve ser menor do que o Tempo do Status Amarelo'
    ),
  tempoAlertaAmarelo: Yup.number()
    .required('Esse campo é obrigatório')
    .min(0, 'O valor não pode ser menor do que zero.')
    .lessThan(
      Yup.ref('tempoAlertaVermelho'),
      'O valor deve ser menor do que o Tempo do Status Vermelho'
    ),
  tempoAlertaVermelho: Yup.number()
    .required('Esse campo é obrigatório')
    .min(0, 'O valor não pode ser menor do que zero.'),
  mensagemBoasVindas: Yup.string().max(
    500,
    'O texto não pode ser superior a 500 caracteres'
  ),
});

const Config: React.FC = () => {
  const { addToast } = useToast();
  const [dataLoad, setDataLoad] = useState<IParametro>({} as IParametro);

  const loadParametro = (): void => {
    const token = localStorage.getItem('@LiveChat:token');
    api
      .get('/parametro', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          const editData = result.data;
          editData.exibeMensagemBoasVindas =
            result.data.exibeMensagemBoasVindas === 'S';
          editData.notificacaoNovoChat =
            result.data.notificacaoNovoChat === 'S';
          editData.notificacaoNovaMsg = result.data.notificacaoNovaMsg === 'S';
          editData.permiteAcessoHstTodos =
            result.data.permiteAcessoHstTodos === 'S';
          editData.tocarTodosDepartamentos =
            result.data.tocarTodosDepartamentos === 'S';

          setDataLoad(editData);
        }
      });
  };

  useEffect(() => {
    loadParametro();
  }, []);

  const hundleSubmit = (values: IParametro): void => {
    const token = localStorage.getItem('@LiveChat:token');

    const formData = new FormData();
    formData.append(
      'seqEmpresa',
      values.seqEmpresa === undefined ? '0' : values.seqEmpresa.toString()
    );
    formData.append('tempoAlertaVerde', values.tempoAlertaVerde.toString());
    formData.append('tempoAlertaAmarelo', values.tempoAlertaAmarelo.toString());
    formData.append(
      'tempoAlertaVermelho',
      values.tempoAlertaVermelho.toString()
    );
    formData.append(
      'exibeMensagemBoasVindas',
      values.exibeMensagemBoasVindas ? 'S' : 'N'
    );
    formData.append('mensagemBoasVindas', values.mensagemBoasVindas);
    formData.append(
      'notificacaoNovoChat',
      values.notificacaoNovoChat ? 'S' : 'N'
    );
    formData.append(
      'notificacaoNovaMsg',
      values.notificacaoNovaMsg ? 'S' : 'N'
    );
    formData.append(
      'permiteAcessoHstTodos',
      values.permiteAcessoHstTodos ? 'S' : 'N'
    );
    formData.append(
      'tocarTodosDepartamentos',
      values.tocarTodosDepartamentos ? 'S' : 'N'
    );

    api
      .post('/parametro', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          addToast({ title: 'Dados atualizados com sucesso', type: 'success' });
        } else {
          addToast({ title: result.message, type: 'error' });
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <div>
      <div
        className="w-100 d-flex align-items-center ps-3"
        style={{
          backgroundColor: '#1A1A1A',
        }}
      >
        <Image
          src={ConfigIcon}
          style={{ width: '1.6rem', height: '1.6rem' }}
          alt="Configurações"
        />
        <span
          className="text-white ms-2"
          style={{
            fontSize: '1.68rem',
            fontWeight: '600',
            backgroundColor: '#1A1A1A',
          }}
        >
          Configurações gerais
        </span>
      </div>
      <div className="ms-2 me-2">
        <Formik
          initialValues={dataLoad || initialValues}
          validationSchema={validationSchemaParametros}
          enableReinitialize
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            hundleSubmit(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
            resetForm,
          }) => (
            <FormMik>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  name="notificacaoNovoChat"
                  label="Exibir notificação para novo chat"
                  style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.notificacaoNovoChat}
                  className="ms-2 mt-2 input-CheckBox d-flex align-items-center justify-content-start"
                />
                <Form.Check
                  type="checkbox"
                  name="notificacaoNovaMsg"
                  label="Exibir notificação para nova mensagem"
                  style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.notificacaoNovaMsg}
                  className="ms-2 mt-2 input-CheckBox d-flex align-items-center justify-content-start"
                />
                <Form.Check
                  type="checkbox"
                  name="permiteAcessoHstTodos"
                  label="Permitir acesso de todos os usuários ao histórico de atendimentos"
                  style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.permiteAcessoHstTodos}
                  className="ms-2 mt-2 input-CheckBox d-flex align-items-center justify-content-start"
                />
                <Form.Check
                  type="checkbox"
                  name="tocarTodosDepartamentos"
                  label="Tocar para todos os usuários independente do departamento"
                  style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.tocarTodosDepartamentos}
                  className="ms-2 mt-2 input-CheckBox d-flex align-items-center justify-content-start"
                />
              </Form.Group>
              <div
                className="ms-2 mt-4 me-2 overflow-hidden"
                style={{
                  borderRadius: '0.68rem',
                  boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#1A1A1A',
                  }}
                >
                  <span
                    className="text-white p-2"
                    style={{ fontSize: '1.25rem' }}
                  >
                    Status de atendimento para Supervisor
                  </span>
                </div>

                <Form.Group className="d-flex align-items-center justify-content-between ps-4 pe-4 mt-3">
                  <Form.Label style={{ fontSize: '1,25rem' }}>
                    Tempo de atendimento bom (verde) em minutos
                  </Form.Label>
                  <Form.Control
                    style={{ width: '11rem' }}
                    type="number"
                    name="tempoAlertaVerde"
                    value={values.tempoAlertaVerde}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={` inputBox ${
                      touched.tempoAlertaVerde && errors.tempoAlertaVerde
                        ? 'is-invalid'
                        : ''
                    }`}
                  />
                  {touched.tempoAlertaVerde && errors.tempoAlertaVerde ? (
                    <div className="invalid-feedback">
                      {errors.tempoAlertaVerde}
                    </div>
                  ) : null}
                </Form.Group>

                <Form.Group className="d-flex align-items-center justify-content-between ps-4 pe-4 mt-3">
                  <Form.Label style={{ fontSize: '1,25rem' }}>
                    Tempo de atendimento médio (amarelo) em minutos
                  </Form.Label>
                  <Form.Control
                    type="number"
                    style={{ width: '11rem' }}
                    name="tempoAlertaAmarelo"
                    value={values.tempoAlertaAmarelo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={` inputBox ${
                      touched.tempoAlertaAmarelo && errors.tempoAlertaAmarelo
                        ? 'is-invalid'
                        : ''
                    }`}
                  />
                  {touched.tempoAlertaAmarelo && errors.tempoAlertaAmarelo ? (
                    <div className="invalid-feedback">
                      {errors.tempoAlertaAmarelo}
                    </div>
                  ) : null}
                </Form.Group>

                <Form.Group className="d-flex align-items-center justify-content-between ps-4 pe-4 mt-3 mb-2">
                  <Form.Label style={{ fontSize: '1,25rem' }}>
                    Tempo de atendimento ruim (vermelho) em minutos
                  </Form.Label>
                  <Form.Control
                    type="number"
                    style={{ width: '11rem' }}
                    name="tempoAlertaVermelho"
                    value={values.tempoAlertaVermelho}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={` inputBox ${
                      touched.tempoAlertaVermelho && errors.tempoAlertaVermelho
                        ? 'is-invalid'
                        : ''
                    }`}
                  />
                  {touched.tempoAlertaVermelho && errors.tempoAlertaVermelho ? (
                    <div className="invalid-feedback">
                      {errors.tempoAlertaVermelho}
                    </div>
                  ) : null}
                </Form.Group>
              </div>

              <div
                className="d-flex align-items-end justify-content-center"
                style={{ height: '13rem' }}
              >
                <Button
                  className="mt-2 me-2 bg-white border-white"
                  style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: '#616161',
                    boxShadow: '0px 3px 4px -1px rgba(0, 0, 0, 0.25)',
                    borderRadius: '0.6875rem',
                    height: '2.8rem',
                  }}
                  onClick={() => {
                    resetForm();
                    loadParametro();
                  }}
                >
                  cancelar
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  className="mt-2 ms-2"
                  style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  disabled={isSubmitting}
                >
                  confirmar
                </Button>
              </div>
            </FormMik>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Config;
